import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LoginPage from "./components/LoginPage";
import SignupPage from "./components/SignupPage";
import ResetPasswordPage from "./components/ResetPasswordPage";
import ForgotPassword from "./components/ForgotPassword";
import Dashboard from "./components/Dashboard";
import UserProfile from "./components/UserProfile";
import FilmPage from "./components/FilmPage";
import ScraperInterface from "./components/ScraperInterface";
import UserComparison from "./components/UserComparison";
import MovieSwapPage from "./components/MovieSwapPage";
import MFLAdmin from "./components/MovieFantasyLeague/Admin";
import MovieFantasyLeague from "./components/MovieFantasyLeague/Dashboard";
import ScoringReference from "./components/MovieFantasyLeague/ScoringReference";
import FilmBreakdown from "./components/MovieFantasyLeague/FilmBreakdown";
import RosterView from "./components/MovieFantasyLeague/RosterView";
import MyPicks from "./components/MovieFantasyLeague/MyPicks";
import HaterRankings2 from "./components/HaterRankings2";
import ProtectedRoute from "./components/ProtectedRoute";
import Stats from "./components/Stats";
import MostWatchedFilms from "./components/MostWatchedFilms";
import OscarsPage from "./components/OscarsPage";
import EventsListPage from "./components/events/EventsListPage";
import EventPage from "./components/events/EventPage";
import EventAdminPage from "./components/events/EventAdminPage";
import MyPicksPage from "./components/events/MyPicksPage";
import MainLayout from "./components/MainLayout";
import ActorGraph from "./components/ActorGraph";
import AdminRefresh from "./components/AdminRefresh";
import UserAdmin from "./components/admin/UserAdmin";
import NotFound from "./components/NotFound";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<MainLayout />}>
          <Route index element={<Stats />} />
          <Route path="/mfl" element={<MovieFantasyLeague />} />
          <Route path="/mfl/scoring-reference" element={<ScoringReference />} />
          <Route path="/mfl/film/:filmSlug" element={<FilmBreakdown />} />
          <Route path="/mfl/roster/:rosterId" element={<RosterView />} />
          <Route
            path="/mfl/my-picks"
            element={
              <ProtectedRoute>
                <MyPicks />
              </ProtectedRoute>
            }
          />
          <Route
            path="/mfl/admin"
            element={
              <ProtectedRoute>
                <MFLAdmin />
              </ProtectedRoute>
            }
          />
          <Route path="/compare" element={<UserComparison />} />
          <Route path="/movie-swap" element={<MovieSwapPage />} />
          <Route
            path="/hater-rankings"
            element={<HaterRankings2 isPublic={true} />}
          />
          <Route path="/stats" element={<Stats />} />
          <Route path="/bpd-40-club" element={<MostWatchedFilms />} />
          <Route path="/oscars-2026" element={<OscarsPage />} />
          <Route path="/events" element={<EventsListPage />} />
          <Route
            path="/events/admin"
            element={
              <ProtectedRoute>
                <EventAdminPage />
              </ProtectedRoute>
            }
          />
          <Route path="/events/:slug" element={<EventPage />} />
          <Route
            path="/events/:slug/my-picks"
            element={
              <ProtectedRoute>
                <MyPicksPage />
              </ProtectedRoute>
            }
          />
          <Route path="/actor-graph" element={<ActorGraph />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/refresh-films"
            element={
              <ProtectedRoute>
                <AdminRefresh />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/users"
            element={
              <ProtectedRoute>
                <UserAdmin />
              </ProtectedRoute>
            }
          />
          <Route path="/user/:username" element={<UserProfile />} />
          <Route path="/film/:filmSlug" element={<FilmPage />} />
          <Route
            path="/fetcher"
            element={
              // <ProtectedRoute>
              <ScraperInterface />
              // </ProtectedRoute>
            }
          />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
